"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _getDefaultValue = _interopRequireDefault(require("./getDefaultValue.js"));
/**
 * Why need initMap?
 * const o = {};
 *
 * Before:
 * if (!o["foo"]) { // <-- u need do it, before every set.
 *  o["foo"] = [];
 * }
 * o.foo.push('bar');
 *
 * After:
 * initMap(o)("foo", []).push('bar');
 */
var initMap = function initMap(o) {
  return function (k, defaultValue) {
    return o[k] || (o[k] = (0, _getDefaultValue["default"])(defaultValue));
  };
};
var _default = exports["default"] = initMap;
module.exports = exports.default;